import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ColumnHeader from './presentational/column_header';

export default class SessionsHeader extends Component {
  static propTypes = {
    columns: PropTypes.array.isRequired,
  };

  _renderColumns() {
    const { columns } = this.props;
    // console.log(columns);
    return columns.map(({ className, title }) => (
      <ColumnHeader title={title} className={className} key={`column-${title}`} />
    ));
  }

  render() {
    return (
      <div className="thead">
        <div className="tr">
          {this._renderColumns()}
          <div className="col-lg-2 col-md-2 mb mb-actions center" />
        </div>
      </div>
    );
  }
}

const getCSS = (css, key) => {
  if (Object.prototype.hasOwnProperty.call(css, key)) return css[key];

  return css.default;
};
